<template>
  <div class="withdraw">
    <Header :title="{name: '支付宝提现'}"></Header>
    <div class="content">
      <div class="account">
        <van-cell title="提现至"
                  class="account_cell"
                  is-link
                  @click="accoutList"
                  :value="real_name" />
      </div>
      <div class="count">
        <p>提现金额</p>
        <div class="money">
          <i>¥</i>
          <input type="text"
                 v-model="amount">
          <span class="withdraw_all"
                @click="withdrawAll">全部提现</span>
        </div>
      </div>
      <p class="have_count">可用余额：{{balance | toFixPrice}}元</p>
      <div class="btn"
           @click="submit">提交提现申请</div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'withdraw',
  components: {
    Header
  },
  data () {
    return {
      real_name: '请绑定账号',
      account_id: '',
      balance: 0,
      amount: ''
    }
  },
  created () {
    if (this.$route.query.account_id) {
      this.account_id = this.$route.query.account_id;
      this.real_name = this.$route.query.real_name;
    } else {
      this.getAccoutList();
    }
    this.getCount();
  },
  methods: {
    accoutList () {
      this.$router.push({ name: 'AccoutList' })
    },
    getCount () {
      this.$http.get('/api/app/balanceCenter').then(data => {
        this.balance = data.balance;
      })
    },
    toFixPrice (val, toFix = 2) {
      let price = 0
      if (val) {
        if (toFix == 2) {
          price = (val / 100).toFixed(2)
        }
        if (toFix == 1) {
          price = (val / 100).toFixed(1)
        }
        if (toFix == 0) {
          price = (val / 100)
        }
      }
      return price
    },
    withdrawAll () {
      this.amount = this.toFixPrice(this.balance);
    },
    getAccoutList () {
      this.$http.get('/api/app/account/info').then(data => {
        data.list.forEach(item => {
          if (item.is_default == 1) {
            this.real_name = item.real_name;
            this.account_id = item.account_id;
          }
        });
      })
    },
    submit () {
      if (!this.account_id) {
        this.$toast('请选择提现账户');
        return;
      }
      console.log(this.amount)
      if (!this.amount) {
        this.$toast('请输入提心金额');
        return;
      }
      let param = { account_id: this.account_id, amount: this.amount * 100 };
      console.log(param)
      this.$http.post('/api/app/transfer', param).then(data => {
        this.$router.push({ name: 'MyAccount' });
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.withdraw {
  @extend %default-bg;
  background-color: #fff;
  font-family: PingFang SC;
  .header {
    border-bottom: 1px solid #f6f6f6;
  }
  .content {
    .account_cell {
      height: 112px;
      line-height: 112px;
      // margin: 0 30px;
      border-bottom: 1px solid #f6f6f6;
      font-size: 30px;
      /deep/ {
        .van-cell__right-icon {
          margin-top: 6px;
          font-size: 30px;
        }
      }
    }
    .count {
      border-bottom: 1px solid #f6f6f6;
      margin: 0 30px;
      p {
        margin: 45px 0 36px 0;
        color: #333333;
        font-size: 26px;
      }
      .money {
        padding: 0 30px;
        // display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      i {
        font-size: 60px;
        font-weight: 600;
        line-height: 88px;
        height: 88px;
        display: inline-block;
        float: left;
      }
      input {
        width: 460px;
        font-size: 88px;
        height: 88px;
        font-weight: 600;
      }
      .withdraw_all {
        color: $theme_color;
        font-size: 28px;
        width: 120px;
        float: right;
        line-height: 88px;
        height: 88px;
        display: inline-block;
        float: right;
      }
    }
    .have_count {
      padding: 24px 30px;
      color: #999999;
      font-size: 24px;
    }
    .btn {
      margin: 0 auto;
      margin-top: 249px;
      width: 690px;
      height: 90px;
      line-height: 90px;
      text-align: center;
      background-color: $theme_color;
      color: #fff;
      font-size: 34px;
      border-radius: 8px;
      font-weight: normal;
    }
  }
}
</style>